// src/quiet-bluebird.js  (CommonJS, plays nicely with your code-base)
const Bluebird = require("bluebird/js/browser/bluebird.min.js");

// turn off the two noisy browser warnings
Bluebird.config({
  warnings: {
    wForgottenReturn: false,
    wNonError: false
  }
});

// make sure everybody else sees the very same instance
module.exports = Bluebird;
